import { withInstall } from '../../../../utils/with-install'
import WMTS from './WMTS.vue'

export const ElAmapLayerWmts = withInstall(WMTS)
export default ElAmapLayerWmts
